module.exports = __webpack_public_path__ + "files/611ece2c2d66c8a2516b7e3a041440a1.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/people-7.png
// module id = 1460
// module chunks = 60